<template>
  <div class="password">
    <div class="headertop flex">
      <span style="flex: 8; font-size: 1.6rem; color: #2bae85; font-weight: 700"
        >云上初阳统一登录认证平台</span
      >
      <span style="float: right; flex: 2">
        <router-link to="/home" class="link">云上初阳PCB网站</router-link>
      </span>
    </div>
    <div class="center flex">
      <div class="Modify">
        <p>登录<img src="../../assets/imges/笔 (2)(1).png" alt="" /></p>
        <hr />
        <ul @keyup.enter="mylogin" style="margin-top: 3rem">
          <li>
            <img src="../../assets/imges/五角星(1).png" alt="" /><span
              >登录账号:</span
            >
            <el-input v-model="login.Phone" placeholder="请输入内容"></el-input>
            <span
              v-if="time == 0"
              @click="SendVerification"
              style="font-size: 0.8rem; color: #f00"
              >发送验证码</span
            >
            <span v-else style="font-size: 0.8rem; color: #f00"
              >{{ time }}重新发送</span
            >
          </li>
          <li>
            <img src="../../assets/imges/五角星(1).png" alt="" /><span
              >登录验证:</span
            >
            <el-input
              v-model="login.validation"
              placeholder="请输入内容"
            ></el-input>
          </li>
          <li
            style="font-size: 0.8rem; text-align: right; padding-right: 10rem"
          >
            <router-link class="link" to="/registered">
              <span style="color: #000; margin-right: 1rem">*新用户注册</span>
            </router-link>
          </li>
          <li style="margin-top: 1.5rem">
            <el-button style="width: 20rem" @click="mylogin" type="warning"
              ><i style="margin-right: 1rem">登</i><i>录</i></el-button
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom">
      <p>云上初阳</p>
      <div class="flex">
        <ul style="flex: 1">
          <li>业务经理:彭易权</li>
          <li>联系电话:0755-23080620</li>
          <li>手机号码:18129846935</li>
          <li>联系 Q Q:574039568</li>
        </ul>
        <ul style="flex: 1">
          <li>业务专员:陈泰先</li>
          <li>联系电话: <span>0755-23080620</span></li>
          <li>手机号码:13129338939</li>
          <li>联系 Q Q: <span>1025203743</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { getPay } from "../../api/http/pay";
import { getLoginApi } from "../../api/http/login";
export default {
  data() {
    return {
      time: 0, //计时器时间
      vftTime: null,
      login: {
        Phone: "", //账号
        validation: "", //验证码
      },
    };
  },
  methods: {
    // 发送验证码
    SendVerification() {
      if (this.login.Phone != "" && this.login.Phone.length == 11) {
        let params = {
          phone: this.login.Phone,
          type: 3,
        };
        getPay.getSendsms(params).then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.time = 60;
            this.vftTime = setInterval(() => {
              --this.time;
              if (this.time == 0) {
                clearInterval(this.vftTime);
              }
              console.log(this.time);
            }, 1000);
            this.$message({
              message: "验证码发送成功!",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请输入正确的手机号",
          type: "error",
        });
      }

      // getPay.getSendsms()
    },
    // 修改密码事件
    mylogin() {
      let params = {
        phone: this.login.Phone,
        verifyCode: this.login.validation,
      };
      getLoginApi.getLoginwx(params).then((res) => {
        if (res.data.code == 200) {
          clearInterval(this.vftTime);
          this.time = 0;
          window.sessionStorage.setItem("token", res.data.data.Token);
          window.sessionStorage.setItem("Avatar", res.data.data.Avatar);
          window.sessionStorage.setItem("Name", res.data.data.Name);
          setTimeout(() => {
            this.$router.push({ path: "/my" });
          }, 2000);
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.password {
  // 底部样式
  .bottom {
    margin: auto;
    width: 100%;
    background-color: #fafafa;
    text-align: center;
    padding-bottom: 1rem;
    position: fixed;
    bottom: 0;
    p {
      font-size: 1.5rem;
      color: #2bae85;
      font-weight: 600;
      margin-top: 1rem;
    }
    .flex {
      width: 350px;
      margin: auto;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
      ul {
        width: 50%;
        li:hover {
          color: #2bae85;
        }
        li {
          text-align: left;
          font-size: 0.8rem;
        }
      }
    }
  }
  // 头部样式
  .headertop {
    width: 60%;
    margin: auto;
    height: 100px;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    span {
      .link {
        color: #6f6f6f;
      }
      .link:hover {
        color: #2bae85;
      }
    }
  }
  // 中间样式
  .center {
    height: 35rem;
    background-color: #2bae85;
    width: 100%;
    justify-content: center;
    align-items: center;
    ul {
      margin: auto;
      text-align: center;
      li {
        height: 4rem;
        .el-button {
          width: 150px;

          i {
            font-style: unset;
            font-size: 1rem;
            text-align: center;
          }
        }
        .el-input {
          width: 200px;
        }
        img {
          width: 1rem;
        }
      }
    }
    .Modify {
      border: 0.1rem solid #dddddd;
      height: 25rem;
      width: 40%;
      background-color: #f8f8f8;
      border-radius: 0.3rem;
      ul {
        width: 50%;
        li {
          text-align: left;
        }
      }
      hr {
        padding-top: 0.2rem;
        background-color: #dedede;
      }
      p {
        font-size: 1.5rem;
        color: #6f6f6f;
        padding-left: 0.8rem;
        padding-bottom: 0.5rem;
        img {
          width: 1rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/ChildComponents/login.vue